export const $ = document.querySelector.bind(document);
export interface MarqueeRectType {
  x: number;
  y: number;
  width: number;
  height: number;
  connectionId: string;
}

export interface RectCoordinateType {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
}

export interface FuzzySearchType {
  id: string;
  address: string;
  zip_code: string;
  town_city: string;
  country_code: string;
  supplier_vat: string;
  supplier_name: string;
  supplier_number: string;
}

export interface TableCoordinateType {
  columns: string[];
  table_areas: any[];
}

export interface AreaItemType {
  x: number;
  y: number;
  z: number;
  id: number;
  width: number;
  height: number;
  resizable: boolean;
}

export interface dynamicObj {
  [key: string]: any;
}

export interface createDocument {
  name: string;
  description: string;
  has_table: boolean;
  doc_type: string;
  document_key: string;
  doc_type_name: string;
  id: string;
}

export interface ColumnDef {
  field: string | number;
  label?: string;
  // add more if needed
}

export type cstmOptions = {
  [key: string]: any;
};

export interface CostingElement {
  value: string;
  label: string;
  charge_icon: string;
}
